import React from "react";
import { Helmet } from "react-helmet";

type FacebookImageMetaType = {
  imageUrl: string;
  imageWidth: string;
  imageHeight: string;
  appId: string;
};

const FacebookImageMeta: React.FC<FacebookImageMetaType> = ({
  imageUrl,
  imageWidth,
  imageHeight,
  appId,
}) => {
  if (!imageUrl) {
    return null;
  }

  return (
    <Helmet>
      <meta property="og:image" content={imageUrl} />
      {imageWidth && <meta property="og:image:width" content={imageWidth} />}
      {imageHeight && <meta property="og:image:height" content={imageHeight} />}
      {appId && <meta property="fb:app_id" content={appId} />}
    </Helmet>
  );
};

export default FacebookImageMeta;
